import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getProductiveCycleList,
	addNewProductiveCycle,
	updateProductiveCycle,
	deleteProductiveCycle,
	getProductiveCycle,
} from '../productiveCycle/thunk';

export const initialState = {
	itemProductiveCycleList: [],
	itemProductiveCycleDetail: null,
	isProductiveCycleLoading: false,
	isProductiveCycleSuccess: false,

	productiveCycleList: [],
	productiveCycleListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
};

const ProductiveCycleSlice = createSlice({
	name: 'ProductiveCycles',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getProductiveCycle.fulfilled, (state, action) => {
			state.isProductiveCycleLoading = false;
			state.isProductiveCycleSuccess = true;
			state.itemProductiveCycleDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getProductiveCycle.pending, state => {
			state.isProductiveCycleLoading = true;
			state.isProductiveCycleSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getProductiveCycle.rejected, (state, action) => {
			state.isProductiveCycleLoading = false;
			state.isProductiveCycleSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getProductiveCycleList.pending, state => {
			state.isProductiveCycleSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getProductiveCycleList.fulfilled, (state, action) => {
			state.itemProductiveCycleList = action.payload;
			state.productiveCycleList = action.payload;
			state.isLoadingList = false;
			state.isProductiveCycleSuccess = true;

			let productiveCycleListSelect = [];
			action.payload.map(item =>
				productiveCycleListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.productiveCycleListSelect = productiveCycleListSelect;
		});
		builder.addCase(getProductiveCycleList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isProductiveCycleSuccess = true;
		});
		builder.addCase(addNewProductiveCycle.fulfilled, (state, action) => {
			state.itemProductiveCycleList.push(action.payload);
			state.productiveCycleList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewProductiveCycle.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewProductiveCycle.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateProductiveCycle.fulfilled, (state, action) => {
			state.itemProductiveCycleList = current(state.itemProductiveCycleList).map(productiveCycle =>
				productiveCycle._id === action.payload._id
					? { ...productiveCycle, ...action.payload }
					: productiveCycle
			);
			state.productiveCycleList = current(state.productiveCycleList).map(productiveCycle => 
				productiveCycle._id === action.payload._id
					? { ...productiveCycle, ...action.payload }
					: productiveCycle
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateProductiveCycle.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
			state.requireCloseModal = false;
		});
		builder.addCase(updateProductiveCycle.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
			state.requireCloseModal = false;
		});

		builder.addCase(deleteProductiveCycle.fulfilled, (state, action) => {
			state.itemProductiveCycleList = current(state.itemProductiveCycleList).filter(
				item => item._id !== action.payload._id
			);
			state.productiveCycleList = current(state.productiveCycleList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteProductiveCycle.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteProductiveCycle.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		});
	},
});

export const { setRequireCloseModal } = ProductiveCycleSlice.actions;

export default ProductiveCycleSlice.reducer;
